module.exports = __webpack_public_path__ + "img/gaia.c49feaac.png";